import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  DataTableModule, SharedModule, ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule,
  DropdownModule, ChartModule, TabViewModule
} from 'primeng/primeng';

import {
  LocationModule
} from '../location/location.module';

import { ReceiptRoutingModule } from './receipt-routing.module';
import { ReceiptService } from './receipt.service';
import { ReceiptComponent } from './receipt.component';
import { ReceiptDetailComponent } from '../receipt-detail/receipt-detail.component';

@NgModule({
  imports: [
    CommonModule,
    ReceiptRoutingModule,
    FormsModule,
    DataTableModule, SharedModule,
    ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule,
    DropdownModule, ChartModule, TabViewModule, LocationModule
  ],
  declarations: [ReceiptComponent, ReceiptDetailComponent],
  providers: [ReceiptService]
})
export class ReceiptModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/receipt/receipt.module.ts